import React      from 'react'
import { Button } from 'sdc-react-basics'

export const CloneButton = ({onClick,style,...params}) =>
<Button icon="copy" onClick={onClick} style={{color: '#9bf', ...style}} {...params} />
